/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { InputDetail, ItemInfo, LegendItem } from './Legend.type';

function getItem<K>(itemInfo: ItemInfo, items: LegendItem<K>[]) {
  const { itemIdx } = itemInfo;

  if (itemIdx == -1) {
    return items[items.length - 1];
  }
  return items[itemIdx];
}

function getNextItemInfo<K>(itemInfo: ItemInfo, items: LegendItem<K>[]) {
  let itemIdx = itemInfo.itemIdx;

  if (itemInfo.itemIdx == -1) {
    itemIdx = items.length - 1;
  }

  itemIdx = Math.min(items.length - 1, itemIdx + 1);

  return { sectionIdx: 0, itemIdx };
}

function getPrevItemInfo<K>(itemInfo: ItemInfo, items: LegendItem<K>[]) {
  let itemIdx = itemInfo.itemIdx;

  if (itemInfo.itemIdx == -1) {
    itemIdx = items.length - 1;
  }

  itemIdx = Math.max(0, itemIdx - 1);
  return { sectionIdx: 0, itemIdx };
}

/**
 * Returns utils functions for navigation in simple legend.
 * @param items
 * @returns
 */
export function getLegendNavUtils<K>(items: LegendItem<K>[]) {
  return {
    getItem: (itemInfo: ItemInfo) => {
      return getItem(itemInfo, items);
    },
    getDetailFromInfo: (itemInfo?: ItemInfo): InputDetail<K> => {
      if (!itemInfo) {
        return { itemId: undefined };
      }
      const item = getItem(itemInfo, items);
      return { itemId: item.id };
    },
    getPrevItemInfo: (itemInfo: ItemInfo) => {
      return getPrevItemInfo(itemInfo, items);
    },
    getNextItemInfo: (itemInfo: ItemInfo) => {
      return getNextItemInfo(itemInfo, items);
    }
  };
}
